import i18next from 'i18next'
import { Typography, Tooltip } from '@mui/material'

import ScrollTable from 'components/global/CUK/ScrollTable'
import TableView, { useTable } from 'packages/ui/Table'

const COLUMNS_CONFIG = [
  {
    name: 'actor',
    header: {
      label: ctx => ctx.t('bypass.table.history_actor_col')
    },
    value: (item, ctx) => (
      <Tooltip title={item.actor === 'job' ? ctx.t('bypass.table.history_actor.job') : item.actor}>
        <i className={`fa-solid fa-${item.actor === 'job' ? 'brackets-curly' : 'user'}`} />
      </Tooltip>
    )
  },
  {
    name: 'action',
    header: {
      label: ctx => ctx.t('bypass.table.history_action_col')
    },
    value: (item, ctx) => (
      <Typography
        component={'span'}
        sx={{ fontSize: 12, color: item.action === 'activate' ? 'success.main' : 'error.main' }}>
        {ctx.t(`bypass.table.status.${item.action === 'activate' ? 'activated' : 'deactivated'}`)}
      </Typography>
    )
  },
  {
    name: 'created_at',
    header: {
      label: ctx => ctx.t('bypass.table.created_at_col')
    },
    value: item =>
      new Date(item.timestamp).toLocaleDateString(i18next.language) +
      ' ' +
      new Date(item.timestamp).toLocaleTimeString(i18next.language)
  }
]

const History = ({item}) => {
  const apiTable = useTable({
    rowKey: 'created_at',
    items: item.history,
    loading: false,
    columns: COLUMNS_CONFIG
  })

  return (
    <ScrollTable>
      <TableView
        apiTable={apiTable}
        view={'card'}
      />
    </ScrollTable>
  )
}

export default History